import React, { useState, useEffect, useMemo } from 'react';
import { ImageIcon, Loader, Loader2 } from 'lucide-react';

import RecentMaps from './recentmaps'

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api';

const MobileMapLayout = ({
  finalImage,
  lastGeneratedSettings,
  isPortrait,
  setEnlargedImage,
  selectedFormat,
  handleSizeSelect,
  isUnlocking,
  setVoucher,
  setSelectedTab,
  setMaxDpisLastMap,
  compareFlashNonce = 0,
}) => {
  const [recentMaps, setRecentMaps] = useState({ maps: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRecentMaps = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/recent_maps`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch recent maps');
      }

      const data = await response.json();
      setRecentMaps(data);
      // if data.maps contains maps, set maxDpisLastMap to the max_dpis of the first map
      if (data.maps && data.maps.length > 0) {
        // setmaxdpislastmap to the max_dpis of the first map
        setMaxDpisLastMap(data.maps[0].max_dpis);
      }
    } catch (error) {
      console.error('Error fetching recent maps:', error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRecentMaps();
  }, []);

  useEffect(() => {
    if (finalImage) {
      fetchRecentMaps();
    }
  }, [finalImage]);

  return (
    <div className="w-full flex flex-col items-center space-y-4">
      <div className="relative w-full max-w-md mx-auto">
        {isLoading ? (
          <div className="w-full aspect-[4/3] bg-gray-100 rounded-lg flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
          </div>
        ) : error ? (
          <div className="w-full aspect-[4/3] bg-gray-100 rounded-lg flex items-center justify-center text-red-500">
            {error}
          </div>
        ) : (
          < RecentMaps
            recentMaps={recentMaps.maps || []}
            onEnlarge={setEnlargedImage}
            handleSizeSelect={handleSizeSelect}
            isUnlocking={isUnlocking}
            setVoucher={setVoucher}
            selectedFormat={selectedFormat}
            isPortrait={isPortrait}
            setSelectedTab={setSelectedTab}
            refreshRecentMaps={fetchRecentMaps}
            compareFlashNonce={compareFlashNonce}
          />
        )
        }
      </div>
    </div>
  );
};

export { MobileMapLayout }